import api from '../../../api';

import type { MutationFunction } from '@tanstack/react-query';
import type { IncentiveCampaignSSOResultType } from 'domains/loyalty.d';

export const getIncentiveCampaignSSO: MutationFunction<IncentiveCampaignSSOResultType> = async () =>
  await api.get('/loyalty/incentive-campaign/marketplace/sso');
